import { Box } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';

const floatOrbs = keyframes`
  0% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(30px, -30px) scale(1.15); }
  100% { transform: translate(0, 0) scale(1); }
`;

const floatOrbsAlt = keyframes`
  0% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(-40px, 30px) scale(1.2); }
  100% { transform: translate(0, 0) scale(1); }
`;

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(24px); }
  to { opacity: 1; transform: translateY(0); }
`;

const shimmer = keyframes`
  0% { background-position: -200% center; }
  100% { background-position: 200% center; }
`;

const pulseDot = keyframes`
  0%, 100% { opacity: 0.3; transform: scale(0.85); }
  50% { opacity: 1; transform: scale(1); }
`;

export const ComingSoonWrapper = styled(Box)(() => `
  position: relative;
  min-height: calc(100vh - 120px);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: radial-gradient(circle at 20% 20%, #fff5f6 0%, #ffffff 45%, #fafafa 100%);
  border-radius: 16px;
`);

export const Orb = styled('span')(() => `
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.45;
  pointer-events: none;

  &.orb-1 {
    width: 320px;
    height: 320px;
    top: -60px;
    left: -40px;
    background: #EB0A1E;
    animation: ${floatOrbs} 12s ease-in-out infinite;
  }

  &.orb-2 {
    width: 260px;
    height: 260px;
    bottom: -80px;
    right: -20px;
    background: #ff8a95;
    animation: ${floatOrbsAlt} 14s ease-in-out infinite;
  }

  &.orb-3 {
    width: 180px;
    height: 180px;
    top: 40%;
    right: 20%;
    background: #ffd0d5;
    animation: ${floatOrbs} 16s ease-in-out infinite;
  }
`);

export const ComingSoonContent = styled(Box)(() => `
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 24px;
  max-width: 640px;
  animation: ${fadeUp} 0.7s ease both;
`);

export const Badge = styled('span')(() => `
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  border-radius: 999px;
  background: rgba(235, 10, 30, 0.08);
  border: 1px solid rgba(235, 10, 30, 0.2);
  color: #EB0A1E;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 28px;
`);

export const BadgeDot = styled('span')(() => `
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #EB0A1E;
  animation: ${pulseDot} 1.6s ease-in-out infinite;
`);

export const ComingSoonTitle = styled('h1')(() => `
  margin: 0;
  font-size: 56px;
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -0.02em;
  background: linear-gradient(90deg, #1a1a1a 0%, #EB0A1E 50%, #1a1a1a 100%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  animation: ${shimmer} 6s linear infinite;
`);

export const ComingSoonPageName = styled('p')(() => `
  margin: 20px 0 0;
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
`);

export const ComingSoonSubtitle = styled('p')(() => `
  margin: 14px 0 0;
  font-size: 16px;
  line-height: 1.6;
  color: #616161;
  max-width: 460px;
`);

export const Dots = styled('div')(() => `
  display: flex;
  gap: 10px;
  margin-top: 36px;

  & span {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #EB0A1E;
    animation: ${pulseDot} 1.4s ease-in-out infinite;
  }

  & span:nth-of-type(2) { animation-delay: 0.2s; }
  & span:nth-of-type(3) { animation-delay: 0.4s; }
`);
